import useFeatureFlag from '../../../hooks/useFeatureFlag'
import ProposalsLegacy from './ProposalsLegacy'
import ProposalsRedesign from './ProposalsRedesign'
import { ProposalJobData } from './proposalsModel'

export type Props = {
  job: ProposalJobData
  onAutomationChange?: (active: boolean) => void
  onLinkCustomerToQbo?: () => void
  onLinkCostCodeToQbo?: (costCodeId: number) => void
}

const Proposals = (props: Props) => {
  const redesignEnabled = useFeatureFlag('proposals-redesign')

  if (redesignEnabled) {
    return <ProposalsRedesign {...props} />
  }
  return <ProposalsLegacy {...props} />
}

export default Proposals
